import React from 'react';

function RecentlyVisitedItemPending() {
    return <div className="recently-visited-item-pending wave-animation" />;
}

function RecentlyVisitedPending() {
    return (
        <div className="live-streams-wrap pending">
            <RecentlyVisitedItemPending />
            <RecentlyVisitedItemPending />
            <RecentlyVisitedItemPending />
            <RecentlyVisitedItemPending />
        </div>
    );
}

export default RecentlyVisitedPending;
